export const truncateText = (text: string, maxLength: number): string => {
  if (!text || typeof text !== "string") return "";
  if (text.length <= maxLength) return text;

  let truncated = text.slice(0, maxLength + 1);

  truncated = truncated.slice(0, Math.min(truncated.length, truncated.lastIndexOf(" ")));

  return truncated + "...";
};
